module.exports = __webpack_public_path__ + "img/mail-icon.9cbfdf24.svg";